import request from "../../utils/request";
import {
    CalculateEndOfServiceInput,
    EndOfServiceDetailsInput,
    EndOfServiceDetailsView,
    EndOfServiceTypeInput,
    EndOfServiceTypeView,
    FinalSettelmentInput,
    FinalSettelmentView,
    MonthlyPayrollView,
    MonthlyPayrollInput,
    PayrollPreflightInput,
    PayrollPreflightView,
    UserBenefitView,
    WpsConfirmView,
    UserEndOfServiceView
} from "../../models/payroll";
import { Bank, Result, User } from "../../models/general";

export async function GetUsersMonthlyPayslips(input : MonthlyPayrollInput) {
    const response = await request.post<Result<MonthlyPayrollView[]>>("MonthlyPayroll/GetUsersMonthlyPayslips", input);
    return response.data;
}

export async function GetPayrollPreflight(input: PayrollPreflightInput) {
    const response = await request.post<Result<PayrollPreflightView>>("MonthlyPayroll/GetPayrollPreflight", input);
    return response.data;
}

export async function MarkMonthlyPayslipsAsPaid(input: MonthlyPayrollInput) {
    const response = await request.post<Result<boolean>>("MonthlyPayroll/MarkMonthlyPayslipsAsPaid", input);
    return response.data;
}

/** UAE: the warnings Mark Paid would raise for these rows. Changes nothing. */
export async function MarkPaidCheck(input: MonthlyPayrollInput) {
    const response = await request.post<Result<WpsConfirmView>>("MonthlyPayroll/MarkPaidCheck", input);
    return response.data;
}

export async function MarkMonthlyPayslipsAsUnpaid(input: MonthlyPayrollInput) {
    const response = await request.post<Result<boolean>>("MonthlyPayroll/MarkMonthlyPayslipsAsUnpaid", input);
    return response.data;
}

// CO-341: year/month name the payroll period the payslips are written for. They MUST be the same values
// the preflight ran against — the wizard's month picker used to reach GetPayrollPreflight only, and the
// write silently used the server's current month instead. Sent as query parameters so the body keeps its
// legacy `string[]` shape (see the controller comment). confirmInFile: UAE, HR ticked the wizard's warning about people
// already in an active WPS file.
export async function GenerateUsersMonthlyPayslips(userIds : string[], year : number, month : number, confirmInFile = false){
    const confirmed = confirmInFile ? "&confirmInFile=true" : "";
    const response=await request.post<Result<boolean>>(`MonthlyPayroll/GenerateUsersMonthlyPayslips?year=${year}&month=${month}${confirmed}`,userIds);
    return response.data;
}